import { render, staticRenderFns } from "./FaceScanFail.vue?vue&type=template&id=d8075612&scoped=true&"
import script from "./FaceScanFail.vue?vue&type=script&lang=js&"
export * from "./FaceScanFail.vue?vue&type=script&lang=js&"
import style0 from "./FaceScanFail.vue?vue&type=style&index=0&id=d8075612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8075612",
  null
  
)

export default component.exports